import React, { useState, useEffect } from "react";
import "../styles/topbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faHouse,
  faBookOpenReader,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faTwitter,
  faYoutube,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const TopBar = () => {
  const [fontSize, setFontSize] = useState(16);
  const [isMenuVisible, setMenuVisible] = useState(false);

  const adjustFontSize = (action) => {
    let newSize;
    if (action === "increase") {
      newSize = fontSize + 2;
    } else if (action === "decrease") {
      newSize = fontSize - 2;
    }
    setFontSize(newSize);
  };

  const resetFontSize = () => {
    setFontSize(16);
  };

  const toggleMenu = () => {
    setMenuVisible(!isMenuVisible);
  };

  useEffect(() => {
    document.body.style.fontSize = `${fontSize}px`;

    const updateFontSize = (selector) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((item) => {
        item.style.fontSize = `${fontSize}px`;
      });
    };

    updateFontSize(".top-bar ul li a");
    updateFontSize(".controllers");
  }, [fontSize]);

  return (
    <div className="top-bar">
      <div className="hamburger-menu" onClick={toggleMenu}>
        <div className="menu-top-icon" id="topbarHamburger">
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </div>
      <div
        id="top-sub-section"
        className={isMenuVisible ? "visible" : "hidden"}
      >
        <ul>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              Yoga Certificate Course
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href="https://docs.google.com/forms/d/e/1FAIpQLSc6-OMxveZ0d6JdzvDiLCvSFdz7hPEdK8pRW-PGa7mMUFGfyw/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Certificate course in concept and application of meditation
                (three months) - Yoga Science Department
              </Dropdown.Item>
              <Dropdown.Item
                href="https://docs.google.com/forms/d/e/1FAIpQLScLZF_qqXPuy878AcPM5bHGcbguUw8tr9-FKc8IV99lg-RFsQ/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Certificate course in advance yogasana (three months) - Yoga
                Science Department
              </Dropdown.Item>
              <Dropdown.Item
                href="https://docs.google.com/forms/d/e/1FAIpQLScfuJxfU0pQcxER3qSDXapxItsDVRvKAAziDtChe-jAtinRJw/vi"
                target="_blank"
                rel="noopener noreferrer"
              >
                Certificate course in pranayama (three months) - Yoga Science
                Department
              </Dropdown.Item>
              <Dropdown.Item
                href="https://docs.google.com/forms/d/e/1FAIpQLSfQD1yDj--Wd3HhMZ8e3e8_bryl-ry0jRwl8L6td6FbP8ohHQ/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Certificate course in yogasana (three months) - Yoga Science
                Department
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Link to={"/departments"}>
            <li>Departments</li>
          </Link>
          <Link to={"/holidays-list"}>
            <li>List of Holidays</li>
          </Link>
          <Link to={"/convocation"}>
            <li>36th Convocation-2024</li>
          </Link>
          <Link to={"/contact"}>
            <li>Contact Us</li>
          </Link>
          <Link
            to={"https://cv.ccsuniversity.ac.in/dynamic-cv/"}
            target="_blank"
          >
            <li>Dynamic CV</li>
          </Link>
          <Link to={"https://ccsuniversity.samarth.ac.in/"} target="_blank">
            <li>CCSU Samarth</li>
          </Link>
          <Link to={"/#achievements"}>
            <li
              style={{
                color: "#14297a",
                background: "#f4c751",
                padding: "5px 20px",
                borderRadius: 50,
              }}
            >
              CCSU Rankings
            </li>
          </Link>
          <Link to={"/sustainability"}>
            <li
              style={{
                color: "#14297a",
                background: "#f4c751",
                padding: "5px 20px",
                borderRadius: 50,
              }}
            >
              Sustainability@CCSU 
            </li>
          </Link>
        </ul>
        <ul>
          <li>
            <Link to={"https://www.facebook.com/CCSUFB"} target="_blank">
              <FontAwesomeIcon icon={faFacebook} color="white" />
            </Link>
          </li>
          <li>
            <Link to={"https://twitter.com/ccsumeerut"} target="_blank">
              <FontAwesomeIcon icon={faTwitter} color="white" />
            </Link>
          </li>
          <li>
            <Link
              to={"https://youtube.com/channel/UCBRUtlVs5IJiAM61KZqDXrg"}
              target="_blank"
            >
              <FontAwesomeIcon icon={faYoutube} color="white" />
            </Link>
          </li>
          <li>
            <Link to={"https://instagram.com/ccsuinsta"} target="_blank">
              <FontAwesomeIcon icon={faInstagram} color="white" />
            </Link>
          </li>
          <li>
            <Link
              to={
                "https://www.linkedin.com/company/ch-charan-singh-university-meerut/"
              }
              target="_blank"
            >
              <FontAwesomeIcon icon={faLinkedin} color="white" />
            </Link>
          </li>
          <li>
            <Link to={"/"}>
              <FontAwesomeIcon icon={faHouse} className="text-white" />{" "}
              <span id="home" className="text-white">
                Home
              </span>
            </Link>
          </li>
          <Link to={"/screen-reader"}>
            <li title="Screen Reader">
              <FontAwesomeIcon icon={faBookOpenReader} color="white" />
            </li>
          </Link>
          <li
            className="controllers"
            onClick={() => adjustFontSize("increase")}
          >
            A+
          </li>
          <li className="controllers" onClick={resetFontSize}>
            A
          </li>
          <li
            className="controllers"
            onClick={() => adjustFontSize("decrease")}
          >
            A-
          </li>
          <li className="google-translate-container">
            <div id="google_translate_element" />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TopBar;
